import { ref, Component } from 'vue'

import { AlertType } from '../types/types'

export type AddParams = {
  // Set the type of popover alert for different levels of emphasis.
  type?: AlertType
  // If bodyComponent is not present, this can be used to provide the body content
  text?: string
  // Vue component for body slot of the modal
  bodyComponent?: Component
  // Passes the props to body component
  bodyProps?: { [key: string]: unknown }
}

const popover = ref<null | AddParams>()

type usePopover = {
  popoverState: typeof popover
  add: (params: AddParams) => void
}

export const usePopover = (): usePopover => {
  const add = (params: AddParams) => {
    popover.value = params
  }

  return {
    add,
    popoverState: popover,
  }
}

export default usePopover
